import { render } from "./StudyPlanSetHost.vue?vue&type=template&id=0882b935"
import script from "./StudyPlanSetHost.vue?vue&type=script&lang=js"
export * from "./StudyPlanSetHost.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__